import Informations from "../Global/Informations";
import { items } from "../../config/menus";
import userAvatar from '../../assets/man.png'
import { useNavigate } from "react-router-dom";
import { useGlobalStore } from "../../store/useGlobalStore";
import { MenuOutlined } from '@ant-design/icons'
import Notifications from "../Global/Notifications";
import { Avatar, Col, Divider, Dropdown, Grid, Layout, Row } from "antd"

const { Header } = Layout
const { useBreakpoint } = Grid;

function AppHeader({ collapsed, setCollapsed, setCurrent }: Readonly<{ collapsed: boolean, setCollapsed: CallableFunction, setCurrent: CallableFunction }>): JSX.Element {
  const screens = useBreakpoint();
  const { user } = useGlobalStore()
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const navigate = useNavigate()

  return (
    <Header className="dashboard-layout-header">
      <Row justify="space-between" style={{ margin: "0px 16px" }}>
        <Col style={{ display: "flex" }}>
          <div
            className="logo-container"
            onClick={() => {
              navigate("/app/welcome");
              setCurrent([''])
            }}
            onKeyDown={(e) => {
              if (e.ctrlKey) {
                navigate("/app/json-simulator")
              }
              if (e.shiftKey) {
                navigate("/app/dm-updater")
              }
              if (e.key === 'Enter' || e.key === ' ') {
                navigate("/app/welcome");
                setCurrent([''])
              }
            }}
            tabIndex={0}
          >
            {/* Logo removed for demo */}
            {/* <div className="logo-title">InsureFlow</div> */}
          </div>
          <div
            className="collapse-icon"
            onClick={toggleCollapsed}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                navigate("/app/welcome");
                setCurrent([''])
              }
            }}
            tabIndex={1}
          >
            <MenuOutlined size={48} />
          </div>
        </Col>
        <Col style={{ display: 'flex', alignItems: 'center' }}>
          {
            (screens.sm || screens.xs) && !screens.md ?
              <Dropdown trigger={["click"]} menu={{ items }} placement="bottomLeft">
                <Avatar src={userAvatar} size={"large"} alt="avatar" />
              </Dropdown>
              :
              <>
                <Informations />
                <Divider type="vertical" />
                <Notifications />
                <Divider type="vertical" />
                <Dropdown trigger={["click"]} menu={{ items }} placement="bottomLeft">
                  <Avatar src={userAvatar} size={"large"} alt="avatar" />
                </Dropdown>
                <span style={{ marginLeft: 4 }}>{user?.first_name} {user?.last_name}</span>
              </>
          }
        </Col>
      </Row>
    </Header >
  )
}

export default AppHeader
